<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="activitytype_name" [(ttModel)]="edit.activitytype_name" ttReadonly></tt-input>
        <tt-input ttLabel="deviationtype_name" [(ttModel)]="edit.deviationtype_name" ttReadonly></tt-input>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="edit.isactive"></tt-checkbox>
        <tt-button-save ttText="activitytypedevtype_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="activitytype_name" tt-model="vm.model.edit.activitytype_name" tt-change="vm.model.edit.activitytype_name = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="deviationtype_name" tt-model="vm.model.edit.deviationtype_name" tt-change="vm.model.edit.deviationtype_name = $value" tt-readonly="true"></tt-input>
        <tt-checkbox class="col-xs-12 sp-0" tt-label="isactive" tt-model="vm.model.edit.isactive" tt-change="vm.model.edit.isactive = $value"></tt-checkbox>
        <tt-button-save class="col-xs-12 sp-0" tt-text="activitytypedevtype_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
